import "./style.css";

function normalizeParagraphs(section) {
  if (Array.isArray(section.paragraphs)) {
    return section.paragraphs.filter(Boolean);
  }

  return section.text ? [section.text] : [];
}

export default function ContentSections({
  sections = [],
  emptyMessage,
  className = "",
}) {
  const visibleSections = sections.filter((section) => {
    if (!section) return false;
    return (
      section.title ||
      normalizeParagraphs(section).length ||
      section.imageUrl
    );
  });

  if (!visibleSections.length) {
    if (!emptyMessage) return null;

    return (
      <section className={`content-sections ${className}`.trim()}>
        <p className="content-sections__empty">{emptyMessage}</p>
      </section>
    );
  }

  return (
    <section className={`content-sections ${className}`.trim()}>
      {visibleSections.map((section, index) => {
        const paragraphs = normalizeParagraphs(section);

        return (
          <article
            key={section.id || section._id || index}
            className="content-sections__item"
          >
            {section.title && (
              <h2 className="content-sections__title">{section.title}</h2>
            )}

            {paragraphs.map((paragraph, paragraphIndex) => (
              <p key={paragraphIndex} className="content-sections__text">
                {paragraph}
              </p>
            ))}

            {section.imageUrl && (
              <div className="content-sections__image">
                <img
                  src={section.imageUrl}
                  alt={section.imageAlt || section.title || ""}
                />
              </div>
            )}
          </article>
        );
      })}
    </section>
  );
}
